"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneClickPurchaseButton = void 0;
const react_1 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const purchase_1 = require("@amzn/monera-app-core/lib/services/actions/purchase");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const utils_1 = require("../../utils");
const styles_1 = require("./styles");
const types_1 = require("./types");
const OneClickPurchaseButton = (props) => {
    var _a;
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const [shoppingPortalRegistryState] = (0, monera_app_core_1.useShoppingPortalStore)();
    const [weblabStoreState] = (0, monera_app_core_1.useWeblabStore)();
    const handlePurchase = (purchaseAction) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const methodName = 'handlePurchase';
        const metricName = 'purchaseAction';
        const cxIdentifier = (0, utils_1.getCxIdentifier)(configStoreState, shoppingPortalRegistryState, weblabStoreState);
        const response = yield purchaseAction({
            requestId: configStoreState.requestId,
            asin: configStoreState.asin,
            tenant: (_b = configStoreState.tenant) !== null && _b !== void 0 ? _b : '',
            marketplaceId: shoppingPortalRegistryState.marketplaceId,
            sessionId: shoppingPortalRegistryState.sessionId,
            ubid: shoppingPortalRegistryState.ubid,
            csrfToken: configStoreState.csrfToken,
            customerId: shoppingPortalRegistryState.customerId,
            paymentMethodId: props.paymentMethodId || '',
            subscriptionData: props.purchaseContext,
            cxIdentifier
        });
        const isSuccess = response.error === undefined;
        (0, metric_helper_1.meterFatals)({
            methodName,
            metricName,
            success: isSuccess,
            fault: !isSuccess,
            requestId: configStoreState.requestId
        });
        return {
            type: isSuccess ? types_1.PurchaseButtonResponseType.SUCCESS : types_1.PurchaseButtonResponseType.ERROR,
            data: response.data,
            error: response.error
        };
    });
    function handleOnClick() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const methodName = 'handleOnClick';
            (0, metric_helper_1.meterFatals)({
                methodName,
                metricName: 'purchaseButtonClicked',
                success: true,
                fault: false,
                requestId: configStoreState.requestId
            });
            monera_app_core_1.LOGGER.info('Purchase button clicked', {
                hasPaymentMethod: !!props.paymentMethodId,
                hasValidateCallback: !!props.validateCallback,
                requestId: configStoreState.requestId
            });
            if (props.validateCallback && !props.validateCallback()) {
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName: 'purchaseValidationFailed',
                    success: false,
                    fault: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.warn('Purchase validation failed', {
                    hasPaymentMethod: !!props.paymentMethodId,
                    requestId: configStoreState.requestId
                });
                return;
            }
            if (!props.paymentMethodId) {
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName: 'purchaseAttemptedWithoutPaymentMethod',
                    success: false,
                    fault: true,
                    requestId: configStoreState.requestId
                });
                monera_app_core_1.LOGGER.warn('Purchase attempted without payment method', {
                    requestId: configStoreState.requestId
                });
                return;
            }
            const response = yield handlePurchase((_a = props.purchaseAction) !== null && _a !== void 0 ? _a : purchase_1.purchaseAction);
            props.callback(response);
        });
    }
    return (react_1.default.createElement(styles_1.Container, { deviceType: props.deviceType },
        react_1.default.createElement(styles_1.OneClickPurchaseButtonStyled, { deviceType: props.deviceType, buttonType: (_a = props.buttonType) !== null && _a !== void 0 ? _a : 'primary', disabled: props.disabled, "data-testid": "one-click-purchase-button", onClick: () => handleOnClick() }, props.text)));
};
exports.OneClickPurchaseButton = OneClickPurchaseButton;
